import { Routes, RouterModule } from "@angular/router";
import { PermissionGuard } from "app/core/service/guard/permission.guard";
import { Roles } from "app/roles";
const {
  ADMIN,
  MANAGER,
  CREATOR,
  RIGHT_HOLDER,
  MANAGER_LIMITED,
  VIEWER,
  VIEWER_LIMITED,
  RIGHT_HOLDER_TEAM,
  CREATOR_TEAM,
  TRUE_SUPER_CONTENT_OWNER
} = Roles;

//Route for content layout with sidebar, navbar and footer.
export const Full_ROUTES: Routes = [
  {
    path: "dashboard",
    data: { permissions: "ALLOW_ALL" },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: "dashboard-graphs",
    data: { permissions: [ADMIN] },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/dashboard-graphs/dashboard-graphs.module").then(
        (m) => m.DashboardGraphsModule
      ),
  },
  {
    path: "admins",
    data: { permissions: [ADMIN] },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/admin/admin.module").then((m) => m.AdminModule),
  },
  {
    path: "libraries",
    data: { permissions: [ADMIN, MANAGER,
      MANAGER_LIMITED,
      VIEWER,
      VIEWER_LIMITED,
      RIGHT_HOLDER,
      RIGHT_HOLDER_TEAM, CREATOR, CREATOR_TEAM, TRUE_SUPER_CONTENT_OWNER] },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/libraries/libraries.module").then((m) => m.LibrariesModule),
  },
  {
    path: "discover",
    data: { permissions: [ADMIN, MANAGER,
      MANAGER_LIMITED,
      VIEWER,
      RIGHT_HOLDER,
      RIGHT_HOLDER_TEAM,
      CREATOR, 
      CREATOR_TEAM,
      VIEWER_LIMITED] },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/ai-search/ai-search.module").then((m) => m.AiSearchModule),
  },
  {
    path: "upload",
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
        RIGHT_HOLDER,
        RIGHT_HOLDER_TEAM,
      ],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/upload/upload.module").then((m) => m.UploadModule),
  },
  {
    path: "creators",
    loadChildren: () =>
      import("app/modules/creator/creator.module").then((m) => m.CreatorModule),
  },
  {
    path: "team-members",
    loadChildren: () =>
      import("app/modules/team-member/team-member.module").then(
        (m) => m.TeamMemberModule
      ),
  },

  {
    path: "contracts",
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        CREATOR,
        CREATOR_TEAM,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
      ],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/contracts/contracts.module").then(
        (m) => m.ContractsModule
      ),
  },
  {
    path: "claim-contracts",
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        CREATOR,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
      ],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/claim-contract-payment/claim-contract-payment.module").then(
        (m) => m.ClaimContractPaymentModule
      ),
  },
  {
    path: "right-holders",
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        RIGHT_HOLDER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
      ],
    },
    loadChildren: () =>
      import("app/modules/right-holders/right-holders.module").then(
        (m) => m.RightHoldersModule
      ),
  },
  {
    path: "super-right-holders",
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        RIGHT_HOLDER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
      ],
    },
    loadChildren: () =>
      import("app/modules/super-right-holders/super-right-holders.module").then(
        (m) => m.SuperRightHoldersModule
      ),
  },
  {
    path: "channels",
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        RIGHT_HOLDER,
        CREATOR,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
        RIGHT_HOLDER_TEAM,
        CREATOR_TEAM,
        TRUE_SUPER_CONTENT_OWNER
      ],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/channels/channels.module").then(
        (m) => m.ChannelsModule
      ),
  },
  {
    path: "drm-youtube-videos",
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        RIGHT_HOLDER,
        CREATOR,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
        RIGHT_HOLDER_TEAM,
        CREATOR_TEAM,
        TRUE_SUPER_CONTENT_OWNER
      ],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/drm-youtube-videos/drm-youtube-videos.module").then(
        (m) => m.DrmYoutubeVideosModule
      ),
  },
  {
    path: "prospective-youtube-videos",
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        RIGHT_HOLDER,
        CREATOR,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
        RIGHT_HOLDER_TEAM,
        CREATOR_TEAM,
      ],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import(
        "app/modules/prospective-sublicensee-creators/prospective-sublicensee-creators.module"
      ).then((m) => m.ProspectiveSublicenseeCreatorsModule),
  },
  {
    path: "sublicensee-creators",
    data: {
      permissions: [RIGHT_HOLDER, RIGHT_HOLDER_TEAM, TRUE_SUPER_CONTENT_OWNER],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/sublicensee-creator/sublicensee-creator.module").then(
        (m) => m.SublicenseeCreatorModule
      ),
  },

  {
    path: "monitoring-channels",
    data: {
      permissions: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/monitoring-channels/monitoring-channels.module").then(
        (m) => m.MonitoringChannelsModule
      ),
  },
  {
    path: "assets",
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
        RIGHT_HOLDER,
        RIGHT_HOLDER_TEAM,
        TRUE_SUPER_CONTENT_OWNER
      ],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/assest/assest.module").then((m) => m.AssestModule),
  },
  {
    path: "monitoring-youtube-videos",
    data: {
      permissions: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import(
        "app/modules/monitoring-youtube-vedios/monitoring-youtube-vedios.module"
      ).then((m) => m.MonitoringYoutubeVediosModule),
  },
  {
    path: "allow-list",
    data: {
      permissions: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED,RIGHT_HOLDER,
        RIGHT_HOLDER_TEAM],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import(
        "app/modules/allow-list/allow-list.module"
      ).then((m) => m.AllowListModule),
  },
  {
    path: "ai-content-removal",
    data: {
      permissions: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED,RIGHT_HOLDER,
        RIGHT_HOLDER_TEAM],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import(
        "app/modules/ai-content-removal/ai-content-removal.module"
      ).then((m) => m.AiContentRemovalModule),
  },
  {
    path: "block-ai",
    data: {
      permissions: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED,RIGHT_HOLDER,
        RIGHT_HOLDER_TEAM],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import(
        "app/modules/block-ai/block-ai.module"
      ).then((m) => m.BlockAiModule),
  },
  {
    path: "auto-sync",
    data: {
      permissions: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import(
        "app/modules/auto-sync/auto-sync.module"
      ).then((m) => m.AutoSyncModule),
  },
  {
    path: "allow-list/add",
    data: {
      permissions: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED,RIGHT_HOLDER,
        RIGHT_HOLDER_TEAM],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import(
        "app/modules/allow-list/allow-list.module"
      ).then((m) => m.AllowListModule),
  },
  {
    path: "categories",
    data: {
      permissions: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/category/category.module").then(
        (m) => m.CategoryModule
      ),
  },
  {
    path: "energy-level",
    data: {
      permissions: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/energy-level/energy-level.module").then(
        (m) => m.EnergyLevelModule
      ),
  },
  {
    path: "artists",
    data: {
      permissions: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/artist/artist.module").then((m) => m.ArtistModule),
  },
  {
    path: "content-library",
    data: {
      permissions: [
        ADMIN,
        RIGHT_HOLDER,
        CREATOR,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
        RIGHT_HOLDER_TEAM,
        CREATOR_TEAM,
        TRUE_SUPER_CONTENT_OWNER
      ],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/content-library/content-library.module").then(
        (m) => m.ContentLibraryModule
      ),
  },
  {
    path: "update-profile",
    data: {
      permissions: [
        ADMIN,
        RIGHT_HOLDER,
        CREATOR,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
        RIGHT_HOLDER_TEAM,
        CREATOR_TEAM,
        TRUE_SUPER_CONTENT_OWNER
      ],
    },
    loadChildren: () =>
      import("app/modules/profile/profile.module").then((m) => m.ProfileModule),
  },
  {
    path: "royalties-earnings",
    data: { permissions: [ADMIN, RIGHT_HOLDER, CREATOR, MANAGER, VIEWER] },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/royalties/royalties.module").then(
        (m) => m.RoyaltiesModule
      ),
  },
  {
    path: "royalties",
    canActivate: [PermissionGuard],
    data: { permissions: [ADMIN, RIGHT_HOLDER, CREATOR, MANAGER, VIEWER] },
    loadChildren: () =>
      import("app/modules/royalties/royalties.module").then(
        (m) => m.RoyaltiesModule
      ),
  },

  {
    path: "claim-detail",
    loadChildren: () =>
      import("app/modules/claim-detail-module/claim-detail-module.module").then(
        (m) => m.ClaimDetailModuleModule
      ),
  },
  {
    path: "transaction",
    loadChildren: () =>
      import("app/modules/transaction/transaction.module").then(
        (m) => m.TransactionModule
      ),
  },
  {
    path: "payment-history",
    loadChildren: () =>
      import("app/modules/payment-history/payment-history.module").then(
        (m) => m.PaymentHistoryModule
      ),
  },
  {
    path: "payment-setting",
    data: {
      permissions: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/payment-setting/payment-setting.module").then(
        (m) => m.PaymentSettingModule
      ),
  },
  // {
  //   path: "pages",
  //   loadChildren: () =>
  //     import("app/pages/full-pages/full-pages.module").then(
  //       (m) => m.FullPagesModule
  //     ),
  // },
  {
    path: "contact-us",
    canActivate: [PermissionGuard],
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
        CREATOR,
      ],
    },
    loadChildren: () =>
      import("app/modules/contact-us/contact-us.module").then(
        (m) => m.ContactUsModule
      ),
  },
  {
    path: "dashboard-notification",
    canActivate: [PermissionGuard],
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED
      ],
    },
    loadChildren: () =>
      import("app/modules/alert/alert.module").then(
        (m) => m.AlertModule
      ),
  },
  {
    path: "resource-tutorial",
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
        RIGHT_HOLDER,
        RIGHT_HOLDER_TEAM
      ]
    },
    canActivate: [PermissionGuard],
    loadChildren: () =>
      import("app/modules/resource-tutorial/resource-tutorial.module").then(
        (m) => m.ResourceTutorialModule
      ),
  },
  {
    path: "activity-log-reports",
    canActivate: [PermissionGuard],
    data: {
      permissions: [
        ADMIN,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
        CREATOR,
      ],
    },
    loadChildren: () =>
      import(
        "app/modules/activity-log-reports/activity-log-reports.module"
      ).then((m) => m.ActivityLogReportsModule),
  },
  {
    path: "inquiry-list",
    canActivate: [PermissionGuard],
    data: {
      permissions: [ADMIN, MANAGER, MANAGER_LIMITED, VIEWER, VIEWER_LIMITED],
    },
    loadChildren: () =>
      import("app/modules/inquiry-list/inquiry.module").then(
        (m) => m.InquiryModule
      ),
  },
  {
    path: "browse",
    canActivate: [PermissionGuard],
    data: {
      permissions: [
        ADMIN,
        CREATOR,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
        CREATOR_TEAM,
      ],
    },
    loadChildren: () =>
      import("app/modules/browse/browse.module").then((m) => m.BrowseModule),
  },
  {
    path: "dashboard-channel",
    canActivate: [PermissionGuard],
    data: {
      permissions: [
        ADMIN,
        CREATOR,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
      ],
    },
    loadChildren: () =>
      import("app/modules/dashboard-channel/dashboard-channel.module").then(
        (m) => m.DashboardChannelModule
      ),
  },
  {
    path: "dashboard-podcast",
    canActivate: [PermissionGuard],
    data: {
      permissions: [
        ADMIN,
        CREATOR,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
      ],
    },
    loadChildren: () =>
      import("app/modules/dashboard-podcast/dashboard-podcast.module").then(
        (m) => m.DashboardPodcastModule
      ),
  },
  {
    path: "dashboard-social-media",
    canActivate: [PermissionGuard],
    data: {
      permissions: [
        ADMIN,
        CREATOR,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
      ],
    },
    loadChildren: () =>
      import(
        "app/modules/dashboard-social-media/dashboard-social-media.module"
      ).then((m) => m.DashboardSocialMediaModule),
  },
  {
    path: "dashboard-shop",
    canActivate: [PermissionGuard],
    data: {
      permissions: [
        ADMIN,
        CREATOR,
        MANAGER,
        MANAGER_LIMITED,
        VIEWER,
        VIEWER_LIMITED,
      ],
    },
    loadChildren: () =>
      import("app/modules/dashboard-shop/dashboard-shop.module").then(
        (m) => m.DashboardShopModule
      ),
  },
];
